// Case-insensitive match on company, name, user code, email and departments.
export const matchesUserSearch = (user, query) => {
  const q = String(query || "").trim().toLowerCase();
  if (!q) return true;
  const departments = (user?.departments || [])
    .map((d) => (typeof d === "string" ? d : d?.department ?? d?.name ?? ""))
    .join(" ");
  return [user?.company, user?.name, user?.user_code, user?.email, departments]
    .filter(Boolean)
    .join(" ")
    .toLowerCase()
    .includes(q);
};
